export const handleModalClose = (
	reason: 'backdropClick' | 'escapeKeyDown',
	callback: () => void,
) => {
	if (reason !== 'backdropClick') {
		callback();
	}
};
